module.exports = __webpack_public_path__ + "static/media/arrow-right.447d5d02.svg";